import { useCallback, useEffect } from 'react';

import { proxy, useSnapshot } from 'valtio';
import { useModal } from '../context/modal';
import { useSecondaryModal } from '../context/secondaryModal';

type HeaderOptions = 'search' | 'hamburger' | 'user';

const HeaderState = proxy<{ opened: HeaderOptions | null }>({
  opened: null,
});

export function useHeaderStore() {
  const { opened } = useSnapshot(HeaderState);

  const close = useCallback(() => {
    HeaderState.opened = null;
  }, []);

  const open = useCallback((option: HeaderOptions) => {
    HeaderState.opened = option;
  }, []);

  const { activeModal: activePrimaryModal } = useModal();
  const { activeModal: secondaryModal } = useSecondaryModal();

  useEffect(() => {
    if (!opened) return;

    if (activePrimaryModal || secondaryModal) {
      close();
    }
  }, [activePrimaryModal, secondaryModal, opened, close]);

  return {
    close,
    open,
    isSearchOpen: opened === 'search',
    isHamburgerMenuOpen: opened === 'hamburger',
    areUserOptionsOpen: opened === 'user',
  };
}
